import React from "react";
import styles from "./CTAs.module.scss";
import For from "@/components/common/For";
import If from "@/components/common/If";
import { Button } from "@/components/actions/Button";
import AnimateIn from "@/components/common/AnimateIn";
import { FileDown } from "lucide-react";
import { TrackedLink } from "@/components/common/TrackedLink";

/**
 *
 * CtAs
 *
 */
const CTAs = ({
  ctas = [],
  align = "center",
  isLight = false,
  ...props
}: any) => {
  // Ensure ctas is always an array
  const ctasArray = Array.isArray(ctas) ? ctas : [];

  const safeCtas = ctasArray.filter((cta: any) => {
    if (!cta) return false;
    const hasDownload =
      cta.type === "Download" && (cta.link || cta.downloadAsset?.[0]?.cdn_url);
    const hasLink = Boolean(cta.title && cta.link);
    const hasPage = Boolean(cta.title && cta.page?.handle);
    // Button CTAs can point straight at a Brandfolder file instead of a link/page
    const hasAsset = Boolean(cta.title && cta.downloadAsset?.[0]?.cdn_url);
    return hasDownload || hasLink || hasPage || hasAsset;
  });

  return (
    <div
      className={`flex flex-wrap flex-col md:flex-row gap-4 ctas ${align === "center" ? "justify-center items-center" : ""}`}
    >
      <For
        each={safeCtas}
        render={(cta, index) => {
          return (
            <AnimateIn
              as="div"
              delay={`delay-${index}`}
              className="w-max  max-w-full"
              key={cta?.sys?.id || `${cta?.title || "cta"}-${index}`}
            >
              <If condition={cta.type === "Download"}>
                <TrackedLink
                  href={cta.link || cta.downloadAsset?.[0]?.cdn_url}
                  className="w-max max-w-full flex gap-4 items-center text-2xl"
                  target="_blank"
                  trackingLabel={cta.title}
                >
                  <FileDown color="currentColor" size={30} />
                  <span className="text-[1.25rem]">{cta.title}</span>
                </TrackedLink>
              </If>
              <If condition={cta.type !== "Download"}>
                <If condition={cta.title && cta.link}>
                  <Button
                    href={cta.link}
                    className="w-max max-w-full"
                    isLight={isLight}
                  >
                    {cta.title}
                  </Button>
                </If>
                <If condition={cta.title && cta.page?.handle}>
                  <Button
                    href={`/${cta.page?.handle}`}
                    className="w-max max-w-full"
                    isLight={isLight}
                  >
                    {cta.title}
                  </Button>
                </If>
                <If
                  condition={
                    cta.title &&
                    !cta.link &&
                    !cta.page?.handle &&
                    cta.downloadAsset?.[0]?.cdn_url
                  }
                >
                  <Button
                    href={cta.downloadAsset?.[0]?.cdn_url}
                    className="w-max max-w-full"
                    isLight={isLight}
                    openInNewTab
                  >
                    {cta.title}
                  </Button>
                </If>
              </If>
            </AnimateIn>
          );
        }}
      />
    </div>
  );
};

export default CTAs;
